<div class="modal change-plan-modal">
  <div class="model-container">
    <div class="modal-header">
        <h3 class="modal-heading" translate>change-plan-modal.title</h3>
        <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon"
          width="28" height="28">
    </div>
    <div class="modal-body">
      <div class="contents">
        <p class="msg" translate>change-plan-modal.message</p>
      </div>
      <div class="modal-actions">
        <button class="button primary" aria-label="Change plan!" (click)="handleChangePlanCalls()" translate>
          change-plan-modal.change-plan-btn
        </button>
      </div>
    </div>
  </div>
</div>